import { createSlice } from '@reduxjs/toolkit';
import { getListNotifications } from './notificationThunk';
import { INotifications } from '~/utils/interface/notifications';

interface NotificationState {
  notifications: INotifications[];
}

const initialState: NotificationState = {
  notifications: [],
};

const notificationSlice = createSlice({
  name: 'notificationSlice',
  initialState,
  reducers: {
    setRefreshList(state, action) {
      state.notifications = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListNotifications.pending, (state) => {})
      .addCase(getListNotifications.fulfilled, (state, action) => {
        state.notifications = action.payload.data;
      })
      .addCase(getListNotifications.rejected, (state) => {});
  },
});

// Actions
export const notificationAction = notificationSlice.actions;
// Reducer
const notificationReducer = notificationSlice.reducer;
export default notificationReducer;
